export function getCountryCodeFromPathname(pathname: Location['pathname'], defaultCountryCode: string) {
  const regex = /^\/(tw|hk|us|my|sg|mo)(\/|$|\?)/
  const match = pathname.toLowerCase().match(regex)

  return (!!match && match[1] ? match[1] : defaultCountryCode).toUpperCase()
}
